import IndustriesGrid from "@/components/site/IndustriesGrid";

export default function IndustriesList() {
  return (
    <main data-testid="page-industries" className="pt-24">
      <section className="container-x pt-16 pb-8">
        <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
          / Industries
        </div>
        <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight max-w-4xl">
          Where our teams go{" "}
          <span className="text-[#00F0FF]">deep</span>.
        </h1>
        <p className="mt-6 text-white/60 max-w-2xl leading-relaxed">
          Each vertical has its own regulatory, physical and cultural
          constraints. We invest years in each one so we can tell you what
          will actually work.
        </p>
      </section>
      <IndustriesGrid />
    </main>
  );
}
